import { Component } from '@angular/core';

@Component({
  selector: 'app-cancellation-renewal-policy',
  imports: [],
  templateUrl: './cancellation-renewal-policy.component.html',
  styleUrl: './cancellation-renewal-policy.component.css'
})
export class CancellationRenewalPolicyComponent {
}
